let productsOnPage = $(".products-on-page");
let nextUrl = $(productsOnPage).data("next-url");
let loadMoreButton = $(".action_button_wrapper .action_button");
let loadingSpinner = $(".action_button_wrapper .loading_spinner");

function loadMoreProducts() {
  $(loadingSpinner).show();
  $(loadMoreButton).hide();

  let data = {
    url: nextUrl,
    type: "GET",
    dataType: "html",
  };

  $.ajax(data).done(function (nextPage) {
    let newProducts = $(nextPage).find(".products-on-page");
    newUrl = $(newProducts).data("next-url");

    nextUrl = newUrl;

    if (newUrl) {
      $(loadMoreButton).show();
    }

    $(loadingSpinner).hide();
    $(productsOnPage).append(newProducts.html());
  });
}
